import { useEffect, useState } from 'react';
import ModalCloseButton from '../../components/generic/ModalCloseButton';
import { Dialog, DialogContent, DialogTitle } from '../../components/ui/dialog';
import { Drawer, DrawerContent } from '../../components/ui/drawer';
import { MultiStepForm } from './MultiStepForm';

function useMediaQuery(query) {
  const [matches, setMatches] = useState(false);
  useEffect(() => {
    const media = window.matchMedia(query);
    if (media.matches !== matches) {
      setMatches(media.matches);
    }
    const listener = () => setMatches(media.matches);
    window.addEventListener('resize', listener);
    return () => window.removeEventListener('resize', listener);
  }, [matches, query]);
  return matches;
}

export function OnboardingModal({
  open,
  onClose,
  onComplete,
  isProfile = false,
  phoneEditable = true,
  isOnboarding = true,
}) {
  const isDesktop = useMediaQuery('(min-width: 640px)');

  if (isDesktop) {
    return (
      <Dialog open={open} modal>
        <DialogContent
          className="max-w-2xl w-full p-0 border-0 bg-transparent shadow-none [&>button]:hidden"
          onPointerDownOutside={(e) => e.preventDefault()}
          onEscapeKeyDown={(e) => e.preventDefault()}
        >
          {/* Hidden title for accessibility */}
          <DialogTitle className="sr-only">Profile Settings</DialogTitle>

          {/* Desktop layout with proper spacing for close button */}
          <div className="relative">
            {isProfile && <ModalCloseButton onClick={onClose} />}
            <div className="max-h-[90vh] h-auto overflow-y-auto rounded-3xl bg-[var(--q3-surface-default)] -mt-6">
              <MultiStepForm onComplete={onComplete} isOnboarding={isOnboarding} phoneEditable={phoneEditable} />
            </div>
          </div>
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <Drawer open={open} onOpenChange={isProfile ? onClose : () => {}} dismissible={isProfile} modal>
      <DrawerContent
        showCloseButton={false}
        className="px-0 py-0 backdrop-blur-sm"
        onPointerDownOutside={isProfile ? undefined : (e) => e.preventDefault()}
        onEscapeKeyDown={isProfile ? undefined : (e) => e.preventDefault()}
      >
        <div className="relative max-h-[90vh] h-auto overflow-y-auto bg-[var(--q3-surface-default)] rounded-t-3xl px-4">
          {isProfile && <ModalCloseButton onClick={onClose} />}
          <MultiStepForm onComplete={onComplete} phoneEditable={phoneEditable} isOnboarding={isOnboarding} />
        </div>
      </DrawerContent>
    </Drawer>
  );
}
